import { useQuery } from '@tanstack/react-query';

import { services } from '../../services';

export const useGetRecognitionRecipient = ({ orderId }, options = {}) =>
  useQuery(['recognitionOrderDetail', orderId], () => services.orderDetail(orderId), {
    staleTime: 20 * 1000,
    ...options
  });
